import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Button } from '@material-ui/core'
import uploadPolicyPic from 'src/assets/PolicyState_images/uploadPolicy.svg'
import verificationPic from 'src/assets/PolicyState_images/verificationPending.svg'
import { INSURANCE_DETAILS } from 'src/utils/constants/InsuranceDetails'
import {
  POLICY_STATE,
  POLICY_STATUS_TYPES,
  TYPE_OF_UPLOAD,
  UPLOAD_POLICY,
} from 'src/utils/constants/common'

const ImageText = (props) => {
  const classes = useStyles()
  const {
    image,
    display,
    imageText,
    downType,
    upType,
    buttonText,
    callinvokeSxp,
    justify,
    policyState,
    renewType,
    totalDaysRem,
  } = props
  let displayStatus =
    policyState === POLICY_STATUS_TYPES?.verificationPending
      ? POLICY_STATE?.NONE
      : POLICY_STATE?.BLOCK
  return (
    <>
      <div style={{ display: display, flexDirection: justify }}>
        {upType === TYPE_OF_UPLOAD?.UP_TYPE ? (
          <div className={classes.autoBox}>
            <div className={classes.uploadPolicyContainer}>
              <div className={classes.subContainer}>
                <div className={classes.imgContainer}>
                  <div className={classes.ImageDiv1}>
                    {policyState ===
                    POLICY_STATUS_TYPES?.verificationPending ? (
                      <img
                        className={classes.Image11}
                        src={verificationPic}
                        alt={'verificationPic'}
                      />
                    ) : (
                      <img
                        className={classes.Image11}
                        src={uploadPolicyPic}
                        alt={'uploadPolicyPic'}
                      />
                    )}
                  </div>
                </div>
                <p className={classes.imageHeader}>
                  {policyState === POLICY_STATUS_TYPES?.verificationPending ? (
                    <t className={classes.verificationPendingContainer}>
                      VERIFICATION PENDING
                    </t>
                  ) : (
                    UPLOAD_POLICY
                  )}
                </p>
              </div>
            </div>
          </div>
        ) : (
          <img className={classes.Image1} src={image} alt={'img'} />
        )}
        {downType === TYPE_OF_UPLOAD?.DOWN_TYPE ? (
          <p className={classes.imageHeader1}>{imageText}</p>
        ) : (
          renewType !== TYPE_OF_UPLOAD?.RENEW_TYPE && (
            <div style={{ display: displayStatus, textAlign: 'center' }}>
              <Button
                onClick={callinvokeSxp}
                className={classes.invokeSxpBtn}
                disabled
              >
                {buttonText}
                {/* <img
                  src={proceedArrow}
                  style={{ paddingLeft: "7px" }}
                  alt={"proceedArrow"}
                /> */}
              </Button>
            </div>
          )
        )}
        {renewType === TYPE_OF_UPLOAD?.RENEW_TYPE && totalDaysRem > 30 ? (
          <p className={classes.renewText}>
            You have{' '}
            <b>
              <span className={classes.txtFormat}>{totalDaysRem}</span>
            </b>{' '}
            more Days to Renew
          </p>
        ) : (
          renewType === TYPE_OF_UPLOAD?.RENEW_TYPE && (
            <p className={classes.renewText}>
              You have{' '}
              <b>
                <span className={classes.txtFormat}>{totalDaysRem}</span>
              </b>{' '}
              more Days to Renew. To Renew call {INSURANCE_DETAILS?.HELP_MOBILE}
            </p>
          )
        )}
      </div>
    </>
  )
}

export default ImageText

const useStyles = makeStyles({
  Image1: {
    display: 'block',
    margin: 'auto',
    padding: '10px 1px 1px 1px',
    '@media (max-width:1600px)': {
      width: '20vw',
    },
  },
  invokeSxpBtn: {
    color: 'white !important',
    marginTop: '20px',
    borderRadius: '10px',
    background: '#112F3C',
    '&:hover': {
      backgroundColor: '#112F3C',
    },
  },
  verificationPendingContainer: { color: '#02A9F4', fontSize: '18px' },
  ImgTxtContainer: { display: 'display', flexDirection: 'justify' },
  Image11: {
    display: 'block',
    margin: 'auto',
    padding: '20px 1px 1px 1px',
    width: '5vw',
    height: '7vh',
  },
  imgContainer: { display: 'flex' },
  imageHeader: {
    fontWeight: '400',
    fontSize: '26px',
    color: 'red',
  },
  subContainer: { display: 'flex', marginTop: '6%' },
  uploadPolicyContainer: {
    display: 'flex',
  },
  imageHeader1: {
    fontWeight: '400',
    margin: 'auto',
    textAlign: 'center',
    '@media (max-width:1100px)': {
      fontWeight: '400',
      fontSize: '12px',
    },
  },
  txtFormat: { fontSize: '24px' },
  renewText: {
    fontWeight: '400',
    margin: '20% auto auto -10%!important',
    color: '#112f3c',
    '@media (min-width:1600px)': {
      fontWeight: '400',
      margin: '15% auto auto -25%!important',
    },
  },
  autoBox: {
    border: '2px dashed #BABABA',
    boxSizing: 'border-box',
    borderRadius: '10px',
    margin: 'auto',
    maxHeight: '30vh',
    padding: '30px',
  },
})
